"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RFTransmitterObject = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
let RFTransmitterObject = class RFTransmitterObject extends core_1.DataObject {
    constructor(uid, calibratedRSSI, txPower) {
        super(uid);
        this.calibratedRSSI = calibratedRSSI;
        this.txPower = txPower;
    }
    /**
     * Get the calibrated rssi at 1 meter
     * @returns {number} Calibrated RSSI
     */
    get calibratedRSSI() {
        var _a;
        return (_a = this._calibratedRSSI) !== null && _a !== void 0 ? _a : this.txPower;
    }
    /**
     * Set the calibrated rssi at 1 meter
     * @param {number} calibratedRSSI Calibrated RSSI > 0
     */
    set calibratedRSSI(calibratedRSSI) {
        if (calibratedRSSI < 0) {
            this._calibratedRSSI = calibratedRSSI;
        }
    }
    /**
     * Get the calibrated RSSI at a specific distance
     * @param {number} distance Distance
     * @param {LengthUnit} [unit] Length Unit
     * @returns {number} RSSI at distance
     */
    getCalibratedRSSI(distance, unit = core_1.LengthUnit.METER) {
        const distanceInMeter = unit.convert(distance, core_1.LengthUnit.METER);
        return Math.ceil(this.calibratedRSSI - (1 - distanceInMeter) * -41);
    }
    /**
     * Set the calibrated RSSI at a specific distance
     * @param {number} rssi Received signal strength indicator
     * @param {number} distance Distance
     * @param {LengthUnit} [unit] Length Unit
     * @returns {RFTransmitterObject} This instance
     */
    setCalibratedRSSI(rssi, distance, unit = core_1.LengthUnit.METER) {
        const distanceInMeter = unit.convert(distance, core_1.LengthUnit.METER);
        this.calibratedRSSI = Math.ceil(rssi + (1 - distanceInMeter) * -41);
        return this;
    }
    /**
     * Set the environment factor of the beacon.
     * Nodes such as [[RelativeRSSIProcessing]] can override this.
     * @returns {number} environment factor
     */
    get environmentFactor() {
        return this._environmentFactor;
    }
    set environmentFactor(environmentFactor) {
        this._environmentFactor = environmentFactor;
    }
};
exports.RFTransmitterObject = RFTransmitterObject;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], RFTransmitterObject.prototype, "txPower", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], RFTransmitterObject.prototype, "frequency", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number),
    tslib_1.__metadata("design:paramtypes", [Number])
], RFTransmitterObject.prototype, "calibratedRSSI", null);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number),
    tslib_1.__metadata("design:paramtypes", [Number])
], RFTransmitterObject.prototype, "environmentFactor", null);
exports.RFTransmitterObject = RFTransmitterObject = tslib_1.__decorate([
    (0, core_1.SerializableObject)(),
    tslib_1.__metadata("design:paramtypes", [String, Number, Number])
], RFTransmitterObject);
//# sourceMappingURL=RFTransmitterObject.js.map